module.exports = __webpack_public_path__ + "media/images/global/icons/book-9946773416720ac72524a1e794c34913.svg";